var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-tire-location-picker__tire",class:_vm.classObject,on:{"click":function($event){return _vm.changeTireLocationState()}}},[_c('i',{staticClass:"fal fa-check"})])}
var staticRenderFns = []

export { render, staticRenderFns }